export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'GridIcon',
  },
  {
    title: 'Projects',
    route: 'project-list',
    icon: 'LayersIcon',
  },
  {
    header: 'Reports',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Metabolic Pathway Analysis',
        route: 'reports-metabolic-pathway-analysis',
        icon: 'DiscIcon',
      },
    ],
  },
  {
    header: 'Algorithms & Datasets',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'File Types',
        route: 'filetypes',
        icon: 'DiscIcon',
      },
      {
        title: 'Algorithm',
        route: 'algorithm-list',
        icon: 'DiscIcon',
      },
      {
        title: 'Datasets',
        route: 'dataset-list',
        icon: 'DiscIcon',
      },
    ],
  },
]
